<template>
  <div class="order-lines">
    <h2>Order lines</h2>
    <div class="preset">
      <button type="button" class="btn btn-light" @click="orderAddLine()">Add Line</button>
      <TaxModal :form="form" :products="products.filter(product => product.category === 'taxes')" />
      <VipModal :form="form" :products="products.filter(product => product.category === 'vip')" />
      <VariousModal :form="form" :products="products.filter(product => product.category === 'various')" />
      <button type="button" class="btn btn-light" @click="orderAddCommentLine()">Add Comment Line</button>
      <CreditcardModal :form="form" />
    </div>

    <table class="table">
      <colgroup>
        <col width="50%" />
        <col width="13%" />
        <col width="13%" />
        <col width="10%" />
        <col width="13%" />
      </colgroup>
      <thead>
        <tr>
          <th>Name</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Subtotal</th>
          <th>Actions</th>
        </tr>
      </thead>

      <draggable
        tag="tbody"
        v-model="form.order_lines"
        handle=".handle"
        @start="drag=true"
        @end="drag=false"
        item-key="id">
        <template #item="{element, index}">
          <tr>
            <OrderLine v-if="element.type == 'vip'" :element="element" />
            <OrderLine v-if="element.type == 'tax'" :element="element" />
            <OrderLine v-if="element.type == 'various'" :element="element" />
            <OrderLine v-if="element.type == 'custom'" :element="element" />
            <OrderComment v-if="element.type == 'comment'" :element="element" />

            <td class="actions">
              <button type="button" class="btn btn-sm btn-light" @click="copyOrderLine(element)" title="Copy"><icon name="copy" class="" width="14" height="14" /></button>
              <button type="button" class="btn btn-sm btn-light handle" title="Move"><icon name="move" class="" width="14" height="14" /></button>
              <button type="button" class="btn btn-sm btn-danger" @click="removeOrderLine(index)"><icon name="close" class="" width="14" height="14" style="fill: #fff;" /></button>
            </td>
          </tr>
        </template>
      </draggable>

      <tfoot v-if="totalSubtotal">
        <tr>
          <th colspan="2"></th>
          <th>Total</th>
          <th colspan="2">$ {{ totalFinal }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Draggable from 'vuedraggable'
import FlightModal from './FlightModal'
import TaxModal from './TaxModal'
import VipModal from './VipModal'
import VariousModal from './VariousModal'
import CreditcardModal from './CreditcardModal'
import OrderLine from './Order/OrderLine'
import OrderComment from './Order/OrderComment'

export default {
  name: 'OrderTable',
  components: {
    Icon,
    Draggable,
    FlightModal,
    TaxModal,
    VipModal,
    VariousModal,
    CreditcardModal,
    OrderLine,
    OrderComment
  },
  props: ['form', 'products'],
  computed: {
    totalSubtotal() {
      let subtotal = 0
      for (let p of this.form.order_lines) {
        subtotal += (p.price * p.qty)
      }
      this.form.subtotal = subtotal
      return parseFloat(subtotal).toFixed(2)
    },
    totalTaxes() {
      let subtotal = 0
      let tax = 0
      for (let p of this.form.order_lines) {
        if (p.type != 'tax') {
          subtotal += (p.price * p.qty)
        }
      }

      for (let p of this.form.order_lines) {
        if (p.type == 'tax') {
          tax += (p.price * p.qty)
        }
      }
      subtotal = subtotal * 0.21;
      subtotal = subtotal + tax
      this.form.taxes = subtotal
      return parseFloat(subtotal).toFixed(2)
    },
    totalFinal() {
      let subtotal = this.form.subtotal
      let taxes = this.form.taxes
      let total = (subtotal + taxes)
      this.form.final_total = subtotal + taxes
      return parseFloat(total).toFixed(2)
    }
  },
  methods: {
    orderAddLine() {
      this.form.order_lines.push({
        type: "custom",
        data: null,
        name: "",
        price: "",
        qty: "",
      })
    },
    orderAddCommentLine () {
      this.form.order_lines.push({
        type: "comment",
        data: null,
        name: "",
        price: "",
        qty: "",
      })
    },
    copyOrderLine(item) {
      this.form.order_lines.push({
        type: item.type,
        data: item.data,
        name: item.name,
        price: item.price,
        qty: item.qty,
      })
    },
    removeOrderLine(index) {
      this.form.order_lines.splice(index, 1);
    },
  }
}
</script>

<style>

</style>
